import React from 'react';

import { Message } from './..';
import ContactUs from './../../../components/contactUs/ContactUs';
import './InvalidMessage.scss';

interface InvalidMessageProps {
  title: string;
  description: string;
}

export const InvalidMessage: React.FC<InvalidMessageProps> = ({
  title,
  description,
}) => {
  return (
    <div className='invalid-message-container'>
      <Message type='error' title={title}>
        <p className='invalid-description'>{description}</p>
        <ContactUs />
      </Message>
    </div>
  );
};
